<template>
  <v-row density="compact">
    <v-col cols="12">
      <v-radio-group
        :model-value="rule.config.direction"
        class="mt-0"
        @update:model-value="updateConfig('direction', $event)"
      >
        <v-radio
          :value="1"
          label="Avg. 13F Ranking is >= the lowest Avg. 13F Ranking of specific # of quarters below:"
        />
        <v-radio
          :value="2"
          label="Avg. 13F Ranking is <= the lowest Avg. 13F Ranking of specific # of quarters below:"
        />
      </v-radio-group>
    </v-col>
    <v-col cols="12" sm="12" md="7">
      <v-text-field
        :model-value="rule.config.number_of_quarters"
        density="compact"
        hide-details
        variant="outlined"
        label="Avg of Past # of Quarters to look at"
        @update:model-value="updateConfig('number_of_quarters', $event)"
      />
    </v-col>
    <v-col cols="12" sm="12" md="7">
      <v-text-field
        :model-value="rule.config.change_min"
        density="compact"
        hide-details
        variant="outlined"
        prefix="by at least"
        label="optional minimum change % from prior quarter"
        @update:model-value="updateConfig('change_min', $event)"
      />
    </v-col>

    <v-col cols="12" sm="12" md="6">
      <v-text-field
        :model-value="rule.config.ranking_min"
        density="compact"
        hide-details
        variant="outlined"
        label="optional min. Avg Ranking"
        @update:model-value="updateConfig('ranking_min', $event)"
      />
    </v-col>
    <v-col cols="12" sm="12" md="6">
      <v-text-field
        :model-value="rule.config.ranking_max"
        density="compact"
        hide-details
        variant="outlined"
        label="optional max. Avg Ranking"
        @update:model-value="updateConfig('ranking_max', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'
import cloneDeep from 'lodash/cloneDeep'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  emits: ['update:rule'],
  data() {
    return {
      high_low: ['new high', 'new low'],
      volume_time_periods: [
        { text: '1 week', value: 7 },
        { text: '2 weeks', value: 14 },
        { text: '3 weeks', value: 21 },
        { text: '4 weeks', value: 28 },
        { text: '90 Days', value: 90 }
      ],
      days_time_periods: [
        { text: '1 week', value: 7 },
        { text: '2 weeks', value: 14 },
        { text: '3 weeks', value: 21 },
        { text: '4 weeks', value: 28 },
        { text: '50 days', value: 50 },
        { text: '90 days', value: 90 },
        { text: '6-months', value: 180 },
        { text: '1 Year', value: 365 }
      ],
      editedIndex: -1,
      defaultAvgRanking: {
        rule_type: '13f_ranking',
        enabled: true,
        direction: 1,
        number_of_quarters: '8',
        change_min: '5',
        ranking_min: null,
        ranking_max: null,
        long_short: 'long'
      },
      editedModel: {}
    }
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},

  mounted() {
    this.editedModel = cloneDeep(this.defaultAvgRanking)
    if (!this.rule.config || !this.rule.config.rule_type || this.rule.trend != '13f_ranking') {
      this.$emit('update:rule', { ...this.rule, config: Object.assign({}, this.defaultAvgRanking) })
    }
  },

  methods: {
    updateConfig(key, value) {
      this.$emit('update:rule', { ...this.rule, config: { ...this.rule.config, [key]: value } })
    }
  }
}
</script>
